import React from "react";
import BlogCTAAssignPage from "../../../../Component/Application/blogs/AddCTA/BlogCTAAssignPage";

const CtaPage = () => {
  return (
    <div className="page-body">
      <BlogCTAAssignPage />
    </div>
  );
};

export default CtaPage;
